import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";

const BLUE = [11, 77, 162];
const idr = (n) => "Rp " + Math.round(n || 0).toLocaleString("id-ID");
const dt = (s) => (s ? new Date(s).toLocaleString("id-ID") : "-");

const loadLogo = async () => {
  try {
    const blob = await (await fetch("/kalabiru-logo.jpg")).blob();
    return await new Promise((res) => { const r = new FileReader(); r.onload = () => res(r.result); r.readAsDataURL(blob); });
  } catch {
    return null;
  }
};

const drawHeader = (doc, logo, title = "LAPORAN SETTLEMENT", subtitle = "Penarikan Saldo Seller") => {
  doc.setFillColor(...BLUE);
  doc.rect(0, 0, 210, 30, "F");
  if (logo) {
    doc.setFillColor(255, 255, 255);
    doc.roundedRect(12, 6, 18, 18, 3, 3, "F");
    doc.addImage(logo, "JPEG", 13, 7, 16, 16);
  }
  doc.setTextColor(255, 255, 255);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(16);
  doc.text("Kalabiru Market", 35, 14);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.text("PT Kalabiru Media  |  kalabiru.com", 35, 20);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(11);
  doc.text(title, 198, 14, { align: "right" });
  doc.setFont("helvetica", "normal");
  doc.setFontSize(8);
  doc.text(subtitle, 198, 20, { align: "right" });
};

export async function exportSettlementPdf(rec) {
  const doc = new jsPDF();
  drawHeader(doc, await loadLogo());

  const info = [
    ["No. Penarikan", rec.mch_order_no || rec.id],
    ["Tanggal", dt(rec.created_at)],
    ["Seller", `${rec.seller_name || "-"} (${rec.seller_phone || "-"})`],
    ["Rekening Tujuan", `${rec.bank_name || "-"} ${rec.account_no || ""} a.n. ${rec.account_name || "-"}`],
    ["Status", rec.status || "-"],
  ];
  autoTable(doc, { startY: 36, body: info, theme: "plain", styles: { fontSize: 10, cellPadding: 1.5 }, columnStyles: { 0: { fontStyle: "bold", cellWidth: 40 } } });

  const orders = rec.orders || [];
  autoTable(doc, {
    startY: doc.lastAutoTable.finalY + 6,
    head: [["#", "Produk", "Pembeli", "No. Order", "Tgl Bayar", "Nominal"]],
    body: orders.map((o, i) => [i + 1, o.product_title, o.buyer_name, o.mch_order_no || o.id.slice(0, 8), dt(o.paid_at), idr(o.price)]),
    foot: [["", "", "", "", "Total Dicairkan", idr(rec.amount)]],
    headStyles: { fillColor: BLUE },
    footStyles: { fillColor: [232, 240, 252], textColor: BLUE, fontStyle: "bold" },
    styles: { fontSize: 8 },
    columnStyles: { 5: { halign: "right" } },
  });

  doc.setFontSize(7);
  doc.setTextColor(130, 130, 130);
  doc.text(`Dicetak ${dt(new Date().toISOString())} - dokumen ini dibuat otomatis oleh sistem Kalabiru dan sah tanpa tanda tangan basah.`, 105, 290, { align: "center" });
  doc.save(`settlement-${rec.mch_order_no || rec.id}.pdf`);
}

export async function exportBuyerInvoicePdf(order) {
  const doc = new jsPDF();
  drawHeader(doc, await loadLogo(), "INVOICE PEMBELIAN", "Bukti Pembelian Preloved");

  const isPaid = order.status === "paid";
  const info = [
    ["No. Pesanan", order.mch_order_no || order.id],
    ["Tanggal", dt(order.created_at)],
    ["Pembeli", `${order.buyer_name || "Pembeli Kalabiru"} (${order.buyer_phone || "-"})`],
    ["Kurir & Alamat", `${order.courier || "J&T Express"} - ${order.address || "-"}`],
    ["Metode Bayar", `${(order.payment_method || "QRIS").toUpperCase()}`],
    ["Status", isPaid ? "LUNAS / DIBAYAR" : "MENUNGGU PEMBAYARAN"],
  ];
  autoTable(doc, {
    startY: 36,
    body: info,
    theme: "plain",
    styles: { fontSize: 10, cellPadding: 1.5 },
    columnStyles: { 0: { fontStyle: "bold", cellWidth: 40 } },
  });

  const price = Number(order.price || order.amount || 0);
  autoTable(doc, {
    startY: doc.lastAutoTable.finalY + 6,
    head: [["#", "Produk", "Kondisi", "Qty", "Harga Satuan", "Total"]],
    body: [
      [1, order.product_title || "Produk Preloved", "Preloved Terverifikasi", 1, idr(price), idr(price)],
    ],
    foot: [
      ["", "", "", "", "Subtotal", idr(price)],
      ["", "", "", "", "Ongkos Kirim", "Rp 0 (Gratis)"],
      ["", "", "", "", "Total Dibayar", idr(order.amount || price)],
    ],
    headStyles: { fillColor: BLUE },
    footStyles: { fillColor: [232, 240, 252], textColor: BLUE, fontStyle: "bold" },
    styles: { fontSize: 8 },
    columnStyles: { 4: { halign: "right" }, 5: { halign: "right" } },
  });

  doc.setFontSize(7);
  doc.setTextColor(130, 130, 130);
  doc.text(`Dicetak ${dt(new Date().toISOString())} - dokumen ini dibuat otomatis oleh sistem Kalabiru dan sah tanpa tanda tangan basah.`, 105, 290, { align: "center" });
  doc.save(`invoice-${order.mch_order_no || order.id}.pdf`);
}
